




























import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import BlackListDto from '@/store/models/maintain/blacklist'
@Component({})
export default class BlackListDetail extends VueBase {
	formState: BlackListDto = new BlackListDto()
	showSchool: boolean = false
	schoolList: Array<any> = []
	showVehicle: boolean = false
	vehicleList: Array<any> = []
	loading: boolean = false
	onClickLeft() {
		window.history.go(-1)
	}
	async getSchoolList() {
		await ajax.get('/api/school/school-to-drop-down')
			.then(rep => {
				this.schoolList.push(...rep.data.result)
			})
	}
	async getVehicleList(schoolcode: string) {
		await ajax.get('/api/vehicle/vehicle-to-drop-down/' + schoolcode)
			.then(rep => {
				this.vehicleList.push(...rep.data.result)
			})
	}
	async onConfirmSchool(val: any) {
		this.formState.schoolShortName = val.shortName
		this.formState.schoolCode = val.schoolCode
		await this.getVehicleList(val.schoolCode)
		this.showSchool = false
	}
	async onConfirmVehicle(val: any) {
		this.formState.vehicleNO = val.vehicleNO
		this.showVehicle = false
	}
	async onSubmit() {
		this.loading = true
		await ajax.post('/api/blacklist', this.formState)
			.then(() => {
				this.$toast.success('新增成功')
				window.history.back()
			})
			.finally(() => {
				this.loading = false
			})
	}
	async created() {
		await this.getSchoolList()
	}
}
